import { Component } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "evrideo-content-control-operation-room",
  templateUrl: "./content-control-operation-room.component.html",
  styleUrl: "./content-control-operation-room.component.scss",
})
export class ContentControlOperationRoomComponent {
  gridSizes: number[] = [2, 4, 6, 9];
  gridSizeControl = new FormControl(2);
  tiles: number[] = [];
  gridStyle: { [key: string]: string } = {};

  ngOnInit() {
    this.gridSizeControl.valueChanges.subscribe((size) => {
      if (size) this.updateGrid(size);
    });
    this.updateGrid(2);
  }
  updateGrid(size: number) {
    this.tiles = Array.from({ length: size }, (_, i) => i + 1);

    let columns: number;
    let rows: number;

    switch (size) {
      case 2:
        columns = 2;
        rows = 1;
        break;
      case 4:
        columns = 2;
        rows = 2;
        break;
      case 6:
        columns = 3;
        rows = 2;
        break;
      case 9:
        columns = 3;
        rows = 3;
        break;
      default:
        columns = 2;
        rows = 1;
    }

    this.gridStyle = {
      "grid-template-columns": `repeat(${columns}, ${Math.max(size < 6 ? 700 : 400, 1400 / size)}px)`,
      "grid-template-rows": `repeat(${rows}, 1fr)`,
    };
  }
}
